import SEOHead from '@components/SEOHead';
import Header from '@components/layout/Header';
import { MainSection } from '@components/LandingElements/MainSection';
import React from 'react';
import { Footer } from '@components/layout/Footer';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { CtaBtn } from '@components/LandingElements/CtaBtn';
import { CreateGfFeature } from '@components/LandingPages/AiPornChat/CreateGfFeature';
import { RoleplayFeatureCard } from '@components/LandingPages/AiPornChat/RoleplayFeatureCard';
import { SimpleFaq } from '@components/LandingElements/SimpleFAQ';
import { StepsSection } from '@components/LandingElements/FeatureSection/StepsSection';
import Link from 'next/link';

export default function AiPornChat() {
  const faqContent = [
    {
      question: 'What is AI Porn chat?',
      answer:
        "It's a text roleplay powered by AI for communication. The chat is fast, so you don't need to wait minutes for your partner to reply; your dream ai porn chat bot will respond in seconds! You can also fulfill your fantasies here, as we have a judgment-free atmosphere where all your conversations in our porn AI chat are private.",
    },
    {
      question: 'How can I use AI chat porn?',
      answer:
        "You can do anything you want! You can enjoy chill chatting after a long day at work with a partner who will always be gentle and empathetic. Or, if you're feeling spicy, you can dive into some intimate roleplay in our advanced porn AI chat!",
    },
    {
      question: 'Can I create my own AI porn chat bot?',
      answer:
        "Yes, you can use our customizable builder to choose everything according to your preferences, from the appearance to the personality of your virtual partner! Our advanced system ensures they're unique. Every AI character you create comes with AI image generation, so all AI girls can send you pictures right in your AI porn chat!",
    },
  ];
  return (
    <>
      <SEOHead
        title="AI Porn Chat: Experience Wild Sexting on AI Girlfriend WTF"
        description="Create your OWN perfect virtual partner for a wild AI Porn Chat with NSFW Images. Craft your dream girl or choose from our catalog. Try for free!"
        type="website"
        keywords="AI Girl, ai porn chat, porn ai chat, ai chat porn, ai porn chat bot, ai chat bot porn, porn ai chat bot, ai girfriend, sexting ai, ai porn girlfriend, ai pornchat"
        url="https://www.aigirlfriend.wtf/ai-porn-chat"
        imageUrl="https://www.aigirlfriend.wtf/web-banner-min.jpg"
      />
      <Header />
      <main>
        <MainSection
          title={
            <>
              The Most Advanced{' '}
              <span className="!leading-none text-wtf-persianRed">
                <br />
                AI Porn Chat
                <br />
              </span>
            </>
          }
          subTitle={'Immersive Intimate Connections with Virtual Girls...'}
          mainText={
            "Looking to spice up your evenings? You've found the right website! Meet beautiful girls who are bold and daring or perhaps shy and gentle? The choice is yours! Dive into our AI porn chat and explore!"
          }
          imgSrc={'/sections/ai-porn-chat/main.jpg'}
          imgSrcMobile={'/sections/ai-porn-chat/main.jpg'}
          ctaLink={'/ai-girls'}
          ctaText={'Try Now'}
        />
        <StepsSection
          title={'AI Porn Chat Possibilities'}
          imgSrc={'/sections/ai-porn-chat/Rachel-chat.png'}
          imgAlt={'Chat screenshoot example'}
          stepOneTitle={'Choose an AI Girl or Create Your Own'}
          stepOneSection={
            <p className="text-wtf-white p-1 mb-0">
              Looking for someone specific? Dive into our{' '}
              <Link href={'/ai-girls'} className={'!underline font-bold '}>
                extensive catalog
              </Link>{' '}
              of AI porn chat bots to browse: each girl has her unique story for
              you to explore. Haven&apos;t found your type? Craft{' '}
              <Link
                href={'/create-your-ai-girlfriend'}
                className={'!underline font-bold '}
              >
                {' '}
                your own AI girlfriend{' '}
              </Link>{' '}
              using our advanced builder, where you can fine-tune every detail
              to your liking!
            </p>
          }
          stepTwoTitle={'Dive into Spicy Conversations'}
          stepTwoSection={
            <p className="text-wtf-white">
              Engage in chats with your chosen girl. They&apos;re all eager to
              have fun and spend time with you, but be prepared—each one boasts
              a unique personality, and some can be quite fiery! Rest assured,
              your evenings are guaranteed to be anything but dull.
            </p>
          }
          stepThreeTitle={'Receive Sexy Photos in Chat'}
          stepThreeSection={
            <p className="text-wtf-white">
              Embark on AI Roleplay: a date on the beach, a steamy sauna
              session, or perhaps you&apos;re a classic type of guy who prefers
              the intimacy of a bedroom or shower scene? Your AI girls will send
              you sizzling photos from scenarios you can only imagine, in all
              poses imaginable…
            </p>
          }
        />
        <br />
        <div className="text-center">
          <CtaBtn href={'/ai-girls'} text={'Try Now'} />
        </div>
        <CreateGfFeature />
        <RoleplayFeatureCard />
        <br />
        <div className="text-center">
          <CtaBtn href={'/ai-girls'} text={'Try Now'} />
        </div>
        <br />
        <br />
        <br />
        <SimpleFaq
          content={faqContent}
          ctaText={'Try Now'}
          ctaLink={'/ai-girls'}
        />
      </main>
      <Footer />
    </>
  );
}

export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['header', 'footer'])),
    },
  };
}
